import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { Observable } from 'rxjs';
import { ServerProvider } from './server';

@Injectable()
export class SettingsProvider {

  private settings: { autoLogin: boolean, agreeTerms: boolean };

  private serverSettings: any = {};

  constructor(private storage: Storage, private server: ServerProvider) {
  }

  public get(): any {
    return this.settings;
  }

  public setAutoLogin(autoLogin) {
    this.settings.autoLogin = autoLogin;
    this.save();
  }

  public setAgreeTerms(agree) {
    this.settings.agreeTerms = agree;
    this.save();
  }

  public load(): Observable<any> {
    return Observable.create(observer => {
      this.storage.get("settings")
        .then((settings) => {
          if (!settings) {
            settings = { autoLogin: true };
          }

          this.settings = settings;
          observer.next(settings);
          observer.complete();
        })
        .catch((error) => {
          console.error(error);
          observer.error(error);
        });
    });
  }

  public save() {
    if (this.settings) {
      this.storage.set("settings", this.settings);
    }
  }

  public loadSettingsFromServer(): Observable<any> {
    return Observable.create(
      (obs) => {
        let request = { operacao: "BUSCAR_CONFIGURACOES" };
        this.server.postData(request, true).subscribe(
          (sucess) => {
            this.serverSettings = sucess.configuracao;
            obs.next(this.serverSettings);
            obs.complete();
          }
        );
      }
    );
  }

  public getServerSettings(): any {
    return this.serverSettings;
  }
}


// WEBPACK FOOTER //
// ./src/providers/settings.ts